$(document).ready(function(){
   $(".block__new-product-slider").slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 7000,
    cssEase: "linear",
    variableWidth: true,
    pauseOnHover: true
  });

$('.block__new-product-acc-container .block__new-product-acc:nth-child(1)').addClass('active');
$('.block__new-product-acc-container .block__new-product-acc:nth-child(1) .block__new-product-acc-content').slideDown();
$('.block__new-product-acc-head').on('click', function() {
    if($(this).parent(".block__new-product-acc").hasClass('active')) {
      $(this).siblings('.block__new-product-acc-content').slideUp();
      $(this).parent(".block__new-product-acc").removeClass('active'); 
    }
    else {
      $('.block__new-product-acc-content').slideUp();
      $('.block__new-product-acc').removeClass('active');
      $(this).siblings('.block__new-product-acc-content').slideToggle();
      $(this).parent(".block__new-product-acc").toggleClass('active');
    }
});

 var $desc = $('.ProductMeta__Description-text');
  var $btn = $('.ProductMeta__Description-btn');

  $desc.addClass('clamped'); // Clamp by default

  $btn.on('click', function () {
    $desc.toggleClass('clamped');

    if ($desc.hasClass('clamped')) {
      $btn.text('Read More');
    } else {
      $btn.text('Read Less');
    }
  });
    
});